export function getClubLogoUrl(logoUrl: string | null, clubId: string): string {
  if (logoUrl) {
    return logoUrl;
  }

  return `https://api.dicebear.com/7.x/identicon/webp?seed=${encodeURIComponent(clubId)}`;
}
